const TogoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112558)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M20.0004 0C19.9859 0.00015625 19.1309 8 19.1309 8H36.0013C32.3525 3.14242 26.5435 0 20.0004 0Z"
        fill="#496E2D"
      />
      <path
        d="M20.0004 39.999C26.5435 39.999 32.3525 36.8566 36.0012 31.999H3.99951C7.64826 36.8566 13.4572 39.999 20.0004 39.999Z"
        fill="#496E2D"
      />
      <path
        d="M39.5999 16H19.1309L20.0004 24H39.5999C39.8624 22.7076 40.0004 21.3699 40.0004 20C40.0004 18.6301 39.8623 17.2924 39.5999 16Z"
        fill="#496E2D"
      />
      <path
        d="M20 24C20 19.8261 20 4.69562 20 0C8.95437 0 0 8.95437 0 20C0 21.3699 0.138125 22.7076 0.400469 24H20Z"
        fill="#D80027"
      />
      <path
        d="M11.0351 9.56543L12.3301 13.551H16.5211L13.1307 16.0145L14.4256 20.0002L11.0351 17.5369L7.64463 20.0002L8.93971 16.0145L5.54932 13.551H9.74018L11.0351 9.56543Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112558">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TogoSvg;
